import {
	SHOW_SUB_HYPE,
	DISMISS_SUB_HYPE,
	TOP_DONATORS_UPDATE,
	NEWEST_SUBSCRIBERS_UPDATE,
	LATEST_SUBSCRIBERS_UPDATE,
	LATEST_DONATORS_UPDATE,
	NEXT_DISPLAYED_SUBLIST,
	SET_SUB_LISTS,
	MOST_DISPUTES_UPDATE,
	TOP_GIFTERS_UPDATE
} from '../actions/subHype';


const initialState = {
	subHypeDisplayed: false,
	subHypePayload: {},
	topDonators: [],
	disputeDestroyers: [],
	latestSubscribers: [],
	newestSubscribers: [],
	latestDonators: [],
	topGifters: [],
	currentDisplayedSubList: null,
	currentDisplayedSubListInnerIndex: null,
	subLists: null,
};


export default (state = initialState, action) => {
	switch(action.type) {
		case MOST_DISPUTES_UPDATE: {
			return {
				...state,
				disputeDestroyers: action.payload
			};
		}
		case SET_SUB_LISTS: {
			return {
				...state,
				subLists: action.payload
			};
		}
		case NEXT_DISPLAYED_SUBLIST:
			const subLists = state.subLists;
			if(!subLists) {
				return state;
			}
			let current = subLists.findIndex((element, index) => {
				if(element.index !== state.currentDisplayedSubList) {
					return false;
				}
				if(state.currentDisplayedSubListInnerIndex && element.innerIndex !== state.currentDisplayedSubListInnerIndex) {
					return false;
				}
				return true;
			});
			let attempts = 0;
			let maxAttempts = 5;
			do {
				current++;
				attempts++;
				if(attempts > maxAttempts) {
					break;
				}

				const currentSelection = subLists[current];
				if(!currentSelection) {
					continue;
				}
				const stateIndexName = currentSelection.index;

				if(currentSelection.type === 'stateDependent') {
					if(state[stateIndexName] && state[stateIndexName].length > 0) { // Check state to see if this field has a value
						break;
					}
				}
				else {
					break; // We probably have something valid
				}
				if(current > subLists.length - 1) {
					current = -1;
				}
			} while(true);
			if(current > subLists.length - 1) {
				current = 0;
			}
			const nextList = subLists[current].index;
			const nextListIndex = subLists[current].innerIndex === undefined ? null : subLists[current].innerIndex;
			return {
				...state,
				currentDisplayedSubList: nextList,
				currentDisplayedSubListInnerIndex: nextListIndex
			};
		case NEWEST_SUBSCRIBERS_UPDATE:
			return {
				...state,
				newestSubscribers: action.payload,
			};
		case TOP_GIFTERS_UPDATE:
			return {
				...state,
				topGifters: action.payload,
			};
		case TOP_DONATORS_UPDATE:
			return {
				...state,
				topDonators: action.payload,
			};
		case LATEST_SUBSCRIBERS_UPDATE:
			return {
				...state,
				latestSubscribers: action.payload,
			};
		case LATEST_DONATORS_UPDATE:
			return {
				...state,
				latestDonators: action.payload,
			};
		case SHOW_SUB_HYPE:
			return {
				...state,
				subHypeDisplayed: true,
				subHypePayload: action.payload
			};
		case DISMISS_SUB_HYPE:
			return {
				...state,
				subHypeDisplayed: false,
			};
		default:
			return state;
	}
}